import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export const SubPage: React.FC = () => {
  const [openSection, setOpenSection] = useState<string | null>(null);
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  return <>
      <section className="w-full bg-white pb-12 px-6 md:px-12 lg:px-20" data-id="element-710">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-711">
          <div data-id="element-712">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6" data-id="element-713">
              „Ein Mensch ist erfolgreich, wenn er zwischen Aufstehen und
              Schlafengehen das tut, was ihm gefällt."
            </h1>
            <p className="text-gray-700" data-id="element-714">Bob Dylan</p>
          </div>
          <div className="flex justify-end" data-id="element-715">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jURsXUMK3ZXDmDos7GJAGA/stock-photo-the-colorful-dye-in-the-water-abstract-background-wallpaper-concept-art-702105091.png" alt="Colorful dye in water" className="max-h-96 object-contain" data-id="element-716" />
          </div>
        </div>
      </section>
      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-717">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-718">
          <div data-id="element-719">
            <p className="mb-6 text-lg" data-id="element-720">
              Veränderung, Wandel, Change – nahezu täglich sind wir damit
              konfrontiert oder persönlich involviert. Veränderung ist oft
              unbequem und kein Selbstläufer.
            </p>
            <p className="mb-6 text-lg" data-id="element-721">
              Ob Karriereentwicklung, anspruchsvolle Führungssituationen oder
              Veränderungen in der Organisation – einer der wichtigsten Hebel
              ist die Konzentration auf Potenziale und Stärken.
            </p>
            <p className="mb-6 text-lg" data-id="element-722">
              Diese zu kennen und gezielt für erfolgreiche Veränderung
              einzusetzen ist mein Beratungsangebot – für Einzelpersonen, Teams
              und Organisationen.
            </p>
          </div>
          <div data-id="element-723">
            <p className="mb-6 text-lg" data-id="element-724">
              wandelwert hat dazu das „Know" und das „How".
            </p>
            <p className="mb-10 text-lg" data-id="element-725">
              Inspirierend, klar und wertschätzend entwickeln wir gemeinsam
              praktische Lösungen mit Tiefgang – für Menschen und Organisationen
              im Wandel.
            </p>
            <div className="border-t border-gray-500" data-id="element-726">
              <button onClick={() => toggleSection('coaching')} className="w-full py-4 flex justify-between items-center text-left hover:opacity-80 transition-opacity" data-id="element-727">
                <h3 className="text-xl" data-id="element-728">Coaching</h3>
                <div className="transition-transform duration-300" style={{
                transform: openSection === 'coaching' ? 'rotate(180deg)' : 'rotate(0deg)'
              }} data-id="element-729">
                  <ChevronDownIcon size={24} data-id="element-730" />
                </div>
              </button>
              <div className="overflow-hidden transition-all duration-500 ease-in-out" style={{
              maxHeight: openSection === 'coaching' ? '500px' : '0px',
              opacity: openSection === 'coaching' ? 1 : 0
            }} data-id="element-731">
                <div className="pb-6" data-id="element-732">
                  <p className="mb-4 text-base" data-id="element-733">
                    Coaching bei wandelwert unterstützt Sie darin, Ihre
                    Potenziale auf den Punkt zu bringen, Sicherheit über den
                    nächsten Schritt zu erlangen und neue Verhaltensweisen
                    authentisch umzusetzen. Für Ihre Karriereentwicklung oder in
                    anspruchsvollen Führungssituationen.
                  </p>
                  <a href="/coaching" className="text-orange-500 hover:text-orange-600" data-id="element-734">
                    Mehr erfahren ...
                  </a>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-500" data-id="element-735">
              <button onClick={() => toggleSection('mentale-gesundheit')} className="w-full py-4 flex justify-between items-center text-left hover:opacity-80 transition-opacity" data-id="element-736">
                <h3 className="text-xl" data-id="element-737">Mentale Gesundheit</h3>
                <div className="transition-transform duration-300" style={{
                transform: openSection === 'mentale-gesundheit' ? 'rotate(180deg)' : 'rotate(0deg)'
              }} data-id="element-738">
                  <ChevronDownIcon size={24} data-id="element-739" />
                </div>
              </button>
              <div className="overflow-hidden transition-all duration-500 ease-in-out" style={{
              maxHeight: openSection === 'mentale-gesundheit' ? '500px' : '0px',
              opacity: openSection === 'mentale-gesundheit' ? 1 : 0
            }} data-id="element-740">
                <div className="pb-6" data-id="element-741">
                  <p className="mb-4 text-base" data-id="element-742">
                    Mentale Gesundheit ist die Grundlage für Leistungsfähigkeit,
                    Zufriedenheit und Erfolg. In einer Welt voller Anforderungen
                    und Veränderungen unterstütze ich Sie dabei, Ihre mentale
                    Widerstandskraft zu stärken, Stress zu bewältigen und ein
                    gesundes Gleichgewicht zu finden – damit Sie Ihr volles
                    Potenzial entfalten können.
                  </p>
                  <a href="/coaching/mentale-gesundheit" className="text-orange-500 hover:text-orange-600" data-id="element-743">
                    Mehr erfahren ...
                  </a>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-500" data-id="element-744">
              <button onClick={() => toggleSection('diagnostik')} className="w-full py-4 flex justify-between items-center text-left hover:opacity-80 transition-opacity" data-id="element-745">
                <h3 className="text-xl" data-id="element-746">Management Diagnostik</h3>
                <div className="transition-transform duration-300" style={{
                transform: openSection === 'diagnostik' ? 'rotate(180deg)' : 'rotate(0deg)'
              }} data-id="element-747">
                  <ChevronDownIcon size={24} data-id="element-748" />
                </div>
              </button>
              <div className="overflow-hidden transition-all duration-500 ease-in-out" style={{
              maxHeight: openSection === 'diagnostik' ? '500px' : '0px',
              opacity: openSection === 'diagnostik' ? 1 : 0
            }} data-id="element-749">
                <div className="pb-6" data-id="element-750">
                  <p className="mb-4 text-base" data-id="element-751">
                    Diagnostik als Fundament: ob bei Eintritt in ein
                    Unternehmen, beim Wechsel auf eine Position mit umfassender
                    Verantwortung oder mit Blick auf ein ganzes Führungsteam –
                    ein professioneller Blick auf Potenzial und Persönlichkeit
                    von Führungskräften ist Grundlage für zielsichere
                    Entwicklung und fundierte Entscheidungen.
                  </p>
                  <a href="/management-diagnostik" className="text-orange-500 hover:text-orange-600" data-id="element-752">
                    Mehr erfahren ...
                  </a>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-500" data-id="element-753">
              <button onClick={() => toggleSection('change-beratung')} className="w-full py-4 flex justify-between items-center text-left hover:opacity-80 transition-opacity" data-id="element-754">
                <h3 className="text-xl" data-id="element-755">Change Beratung</h3>
                <div className="transition-transform duration-300" style={{
                transform: openSection === 'change-beratung' ? 'rotate(180deg)' : 'rotate(0deg)'
              }} data-id="element-756">
                  <ChevronDownIcon size={24} data-id="element-757" />
                </div>
              </button>
              <div className="overflow-hidden transition-all duration-500 ease-in-out" style={{
              maxHeight: openSection === 'change-beratung' ? '500px' : '0px',
              opacity: openSection === 'change-beratung' ? 1 : 0
            }} data-id="element-758">
                <div className="pb-6" data-id="element-759">
                  <p className="mb-4 text-base" data-id="element-760">
                    Erfolgreiche Veränderung braucht mehr als einen Plan – sie
                    braucht Menschen, die den Wandel mittragen. Mit einem
                    ganzheitlichen Ansatz unterstütze ich Ihre Organisation
                    dabei, Veränderungen nachhaltig zu gestalten: von der
                    Konzeption über die Kommunikation bis zur Umsetzung. Damit
                    Transformation gelingt und Potenziale freigesetzt werden.
                  </p>
                  <a href="/change-beratung" className="text-orange-500 hover:text-orange-600" data-id="element-761">
                    Mehr erfahren ...
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};